
// Slick carousel (used on testimonials) http://kenwheeler.github.io/slick/
//import jquery from 'jquery'

import 'slick-carousel';

// window.jQuery = window.$ = $;

// Slick (Slider) http://kenwheeler.github.io/slick/
// Better include this before basicscroll
(function($) { "use strict";

	// Hero Slider - PIANO
	var $slider = $('.js-hero-slider-piano');
	
	// check page contains element
	if( $slider.length ) {
		
		
		// On first initialization
		$slider.on('init', function(slick) {
			
			let firstItem = $('.section-hero-slider-piano .slick-dots li:first-child');
			
			// To trigger the first item's transition on page load
			firstItem.removeClass('slick-active');
			
			setTimeout(function() {
				firstItem.addClass('slick-active');
			}, 1);

		});
		
		// On before slide change
		$slider.on('beforeChange', function(event, slick, currentSlide, nextSlide){
			
			$('body').addClass('js-hero-active'); //Used to adjust animation-duration in CSS after the first slide is cycled.

		});
		
		// initialize and configure.
		$slider.slick({
			fade: true,
			dots: true,
			arrows: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			draggable: false,
			touchMove: false,
			swipeToSlide: false,
			swipe: false,
			autoplay: true,
			infinite: true,
			autoplaySpeed: 5000, // TODO SET BACK TO 5sec
			speed: 800,
			appendDots: $('.section-hero-slider-piano__paging'),
			customPaging: function(slider, i) {
					i = i+1;
					return '<span class="progress-number-piano">' + i + '</span>';
			}
		});
		
		
	}



	// Hero Slider - OPO
	// check page contains element
	if( $('.js-hero-slider').length ) {

		$('.hero-slide')
			.on('activate-slide-colors', function (e, eventInfo) {
				// console.log($(this).attr('class'));
				//remove current js-hero-is-style-bg-? and js-hero-is-style-fg-? classes in body
				let body_classes = $('body').attr('class').split(/\s+/);
				$.each(body_classes, function(index, classname) {
					if (classname.startsWith('js-hero-is-style-fg-') || classname.startsWith('js-hero-is-style-bg-')) {
						$('body').removeClass(classname);
					}
				});

				//add js-hero-if-bg-? and js-hero-is-fg-? classes to body, following the NEXT slide color scheme
				let current_slide_classes = $(this).attr('class').split(/\s+/);
				$.each(current_slide_classes, function(index, classname) {
					if (classname.startsWith('is-style-fg-') || classname.startsWith('is-style-bg-')) {
						$('body').addClass('js-hero-' + classname);
					}
				});
			})
			.eq(0)
			.trigger('activate-slide-colors') //trigger the colors at page loading
		;

		// initialize and configure.
		$('.js-hero-slider').slick({
			dots: true,
			arrows: false,
			pauseOnFocus: false,
			pauseOnHover: false,
			draggable: false,
			touchMove: false,
			swipeToSlide: false,
			swipe: false,
			autoplay: true,
			infinite: true,
			autoplaySpeed: 5000,
			speed: 800,
			cssEase: 'cubic-bezier(0.890, 0.180, 0.120, 0.865)',
			appendDots: $('.section-hero-slider__footer'),
			customPaging: function(slider, i) {
					let circles = '<svg height="50" width="50"><circle cx="25" cy="25" r="18" stroke="red" stroke-width="1" fill="transparent" /><circle class="progress-level" cx="25" cy="25" r="18" stroke="blue" stroke-width="4" fill="transparent" /></svg>';
					i = i+1;
					return '<div class="progress-wheel"><span class="progress-number">' + i + '</span>' + circles + '</div>';
			}
		});
		
		// On before slide change
		$('.js-hero-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){

			$('body').addClass('js-hero-active'); //Used to adjust animation-duration in css after the first slide is cycled.

			$('.hero-slide', slick.$slides[nextSlide]).trigger('activate-slide-colors');

			//console.log('.main-nav classes after: ', $('.main-nav').attr('class'));

		});

		//Hero slider hover event callbacks
		$('.js-hero-slider .hero-slide__inner *').hover(function() {
			$('body').addClass('js-hero-hover');
		},function() {
			$('body').removeClass('js-hero-hover');
		})
	}



	// Tease Slider
	// check page contains element
	if( $('.js-tease-slider').length ) {


		$('.js-tease-slider')
			.on('activate-carousel', function (e, eventInfo) {

				if ($(this).data('active-carousel') === true) {
					return; //ensure we slick the carousel only if needed
				}

				$(this).slick({
					dots: false,
					arrows: true,
					slidesToShow: 3,
					slidesToScroll: 3,
					// pauseOnFocus: false,
					pauseOnHover: true,
					autoplay: false,
					// autoplaySpeed: 4000,
					// speed: 300,
					prevArrow: '<span class="slick-prev icon-carousel-left"><span class="path1"></span><span class="path2"></span></span>',
					nextArrow: '<span class="slick-next icon-carousel-right"><span class="path1"></span><span class="path2"></span></span>',
					responsive: [
						{
							breakpoint: 1000,
							settings: {
								centerMode: true,
								centerPadding: '40px',
								slidesToShow: 2
							}
						},
						{
							breakpoint: 750,
							settings: {
								centerMode: true,
								centerPadding: '100px',
								slidesToShow: 1
							}
						},
						{
							breakpoint: 650,
							settings: {
								centerMode: true,
								centerPadding: '0px',
								slidesToShow: 1
							}
						}
					]
				})

				$(this).data('active-carousel', true); //set the carousel as active
			})
			.on('deactivate-carousel', function (e, eventInfo) {
				if ($(this).data('active-carousel') === false) {
					return; //ensure we unslick the carousel only if needed
				}
				$(this).slick('unslick');
				$(this).data('active-carousel', false); //set carousel as non-active
			})
			.trigger('activate-carousel') //trigger the carousel at page loading
		;
	}




	// Featured Events Slider
	// check page contains element
	if( $('.js-featured-events-slider').length ) {

		$('.js-featured-events-slider').slick({
			dots: true,
			arrows: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			// pauseOnFocus: false,
			pauseOnHover: true,
			autoplay: false,
			// autoplaySpeed: 4000,
			// speed: 300,
			prevArrow: '<span class="slick-prev icon-carousel-left"><span class="path1"></span><span class="path2"></span></span>',
			nextArrow: '<span class="slick-next icon-carousel-right"><span class="path1"></span><span class="path2"></span></span>',
			cssEase: 'cubic-bezier(0.890, 0.180, 0.120, 0.865)',
			appendDots: $('.section-featured-events__paging'),
			appendArrows: $('.section-featured-events__arrows'),
			customPaging: function(slider, i) {
				//get the slide number i, find it's title, and grab the a tag's html content
				return $(slider['$slides'][i]).find('.featured-event__title a').html()
			}
		})
		
	}





	// Quotes Slider
	// check page contains element
	if( $('.section-quotes-slider').length ) {

		// initialize and configure.
		$('.js-quotes-slider').slick({
			infinite: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			// dots: true,
			// arrows: false,
			// pauseOnFocus: false,
			// pauseOnHover: false,
			// draggable: false,
			// autoplay: true,
			// autoplaySpeed: 5000,
			// speed: 300,
			// appendDots: $('.section-hero-slider__footer'),
			//
		});

	}
		
		
		
	// Quotes Carousel
	// check page contains element
	if( $('.js-quotes-carousel').length ) {

		$('.js-quotes-carousel').slick({
					dots: false,
					arrows: true,
					slidesToShow: 2,
					slidesToScroll: 1,
					// pauseOnFocus: false,
					pauseOnHover: true,
					autoplay: false,
					// autoplaySpeed: 4000,
					// speed: 300,
					appendArrows: $('.quotes-carousel__arrows'),
					prevArrow: '<span class="slick-prev icon-carousel-left"><span class="path1"></span><span class="path2"></span></span>',
					nextArrow: '<span class="slick-next icon-carousel-right"><span class="path1"></span><span class="path2"></span></span>',
					responsive: [
						{
							breakpoint: 750,
							settings: {
								slidesToShow: 1
							}
						}
					]
		});
	}
		
		
		
		

})(jQuery);
